import { Empty } from "components/Empty";
import FilterButtonGroup from "components/FilterButtonGroup";
import { useField } from "lib/form";
import React from "react";
import { useFilter } from "services/filter";
import { useCount } from "services/search";
import styled from "styled-components";
import { mq, device } from "lib/media-query";

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    ${mq.to(device.TABLET)`
     grid-template-columns: 1fr;
  `};
    ${({ condensed }) => (condensed ? "grid-template-columns: 1fr" : "")}
`;

export const AantalZitplaatsenFilter = ({ condensed }) => {
    const filterOptions = useFilter("aantalZitplaatsen");
    const count = useCount("aantalZitplaatsen");
    const [value, , onChange] = useField("aantalZitplaatsen");

    const options =
        filterOptions.map((option) => ({
            id: option,
            displayName: `${option}`,
            naam: `${option}`,
            aantal: count[option] || 0
        })) || [];

    return (
        <Grid condensed={condensed}>
            <FilterButtonGroup
                filterId="filter-aantal-zitplaatsen"
                options={options}
                value={value || []}
                handleChange={(_, v) => onChange(v)}
                datalayerKey="aantalZitplaatsen"
                columns={condensed ? 2 : 5}
            />
            <Empty />
        </Grid>
    );
};
